import { middleWareWrapper } from './middleware-utils';
import { cmxRuntime } from '@codametrix/ui-common';
export let isNewDesign;
/**
 * Middleware that checks the application configuration and runtime overrides to determine if the new admin design should be used.
 *
 * @param api The Redux middleware API, including the current application state.
 * @returns A middleware function that checks the new design configuration and sets the `isNewDesign` flag.
 */ const newDesignMiddlewareProcessor = (api, next, action)=>{
    const { ui: { config } } = api.getState();
    isNewDesign = (config.isNewDesign || cmxRuntime.runtimeOverrides?.newAdminDesign === 'true') && cmxRuntime.runtimeOverrides?.newAdminDesign !== 'false';
    return next(action);
};
const newDesignMiddleware = middleWareWrapper(newDesignMiddlewareProcessor);
export default newDesignMiddleware;
